import { DelayNotificationTemplate } from "../../Templates/DelayNotificationTemplate";

export const DelayNotification = () => {
    return <DelayNotificationTemplate />
};